import React, { useMemo } from 'react';
import { buildMailtoUrl } from '../../lib/attribution';
import { CONTACT_CHANNELS } from '../../lib/analytics.constants';
import { trackEvent } from '../../lib/analytics';

export default function EmailLink({
  email,
  subject = 'Consulta desde la web',
  ctaId,
  ctaLocation,
  className,
  children,
  onClick,
  ...props
}) {
  const href = useMemo(
    () => buildMailtoUrl({ email, subject, ctaId }),
    [email, subject, ctaId]
  );

  const handleClick = (event) => {
    trackEvent('email_click', {
      cta_id: ctaId,
      cta_location: ctaLocation,
      contact_channel: CONTACT_CHANNELS.EMAIL,
    });
    onClick?.(event);
  };

  return (
    <a href={href} className={className} onClick={handleClick} {...props}>
      {children}
    </a>
  );
}
